import type { SxProps, Theme } from '@mui/material';

export const headerContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mb: 3,
};

export const titleTypography: SxProps<Theme> = {
  fontFamily: 'Space Grotesk, sans-serif',
  fontWeight: 700,
  fontSize: { xs: 24, sm: 32 },
};

export const detailsButton: SxProps<Theme> = {
  borderRadius: 2,
  textTransform: 'none',
  fontFamily: 'Space Grotesk, sans-serif',
  fontWeight: 500,
};

export const card: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.background.paper,
  border: (theme) => `1px solid ${theme.palette.divider}`,
  borderRadius: 2,
};

export const cardContent: SxProps<Theme> = {
  padding: 0,
  '&:last-child': {
    paddingBottom: 0,
  },
};

export const headerCell: SxProps<Theme> = {
  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
  padding: 2,
};

export const headerCellWithWidth: SxProps<Theme> = {
  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
  padding: 2,
  width: '40%',
};

export const headerTypography: SxProps<Theme> = {
  fontFamily: 'Space Grotesk, sans-serif',
  fontWeight: 500,
  fontSize: 14,
  textAlign: 'center',
};

export const tableRow: SxProps<Theme> = {
  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
};

export const lastTableRow: SxProps<Theme> = {
  borderBottom: 'none',
};

export const dataCell: SxProps<Theme> = {
  padding: 2,
  borderBottom: 'none',
};

export const itemContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
};

export const itemTypography: SxProps<Theme> = {
  fontFamily: 'Space Grotesk, sans-serif',
  fontWeight: 400,
  fontSize: 16,
};

export const typeBadge: SxProps<Theme> = {
  display: 'inline-flex',
  minHeight: '24px',
  maxHeight: '24px',
  padding: '3px 4px',
  alignItems: 'center',
  borderRadius: '100px',
  border: (theme) =>
    theme.palette.mode === 'dark'
      ? '1px solid #616161'
      : `1px solid ${theme.palette.divider}`,
  backgroundColor: (theme) =>
    theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.04)',
};

export const badgeTypography: SxProps<Theme> = {
  fontFamily: 'Space Grotesk, sans-serif',
  fontWeight: 400,
  fontSize: 12,
};

export const metricTypography: SxProps<Theme> = {
  fontFamily: 'Space Grotesk, sans-serif',
  fontWeight: 400,
  fontSize: 14,
  textAlign: 'center',
};
